import { useEffect } from "react";
import { createPortal } from "react-dom";

export const EditorModal = ({ children, onClose, testId }) => {
  useEffect(() => {
    function onKey(event) {
      if (event.key === "Escape") {
        onClose();
      }
    }
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return createPortal(
    <div
      className="editor-modal-backdrop"
      data-testid={testId}
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="editor-modal" role="dialog" aria-modal="true">
        {children}
      </div>
    </div>,
    document.body,
  );
};
